import FactDrawer from '@/cam-admin/control-panel/FactDrawer';
import { CARE_PROFILE } from '@/karehero-app/tell-us-once/intake/content';

/**
 * The recipient's record, editable from the CAM side.
 *
 * The same CARE_PROFILE groups the member's About tab renders, so a care
 * expert changes a fact in the same object the family sees. A CAM-only form
 * would be a second definition of what a fact is and would drift from the
 * member's the first time a question changed.
 *
 * Opened by Edit on the recipient card. The card carries the four things worth
 * seeing at a glance and this is the rest of the record behind them.
 */
const ProfileDrawer = ({
  open,
  onSave,
  onClose,
}: {
  open: boolean;
  onSave: () => void;
  onClose: () => void;
}) => (
  <FactDrawer
    open={open}
    title={CARE_PROFILE.person}
    subtitle={CARE_PROFILE.subtitle}
    groups={CARE_PROFILE.groups}
    onSave={onSave}
    onClose={onClose}
  />
);

export default ProfileDrawer;
